import ComparisonTable from './ComparisonTable';
import GlossaryLink from './common/GlossaryLink';

const GlobalCARTBenchmark = ({ indication = 'B-ALL' }) => {
  return (
    <div className="bg-white rounded-2xl shadow-lg border border-gray-200 overflow-hidden">
      <div className="bg-gradient-to-r from-teal-50 to-blue-50 px-4 py-3 border-b border-gray-200">
        <h2 className="text-xl font-bold text-gray-900">
          Performance Benchmark
        </h2>
        <p className="text-sm text-teal-700 font-semibold mt-0.5">Global CAR-T Comparative Analysis</p>
      </div>

      <div className="p-4">
        <ComparisonTable diseaseType={indication} />

        {/* Clinical Interpretation — commented out per client request
        <div className="mt-4 bg-blue-50 border border-blue-200 rounded-lg p-3">
          <div className="flex items-start space-x-3">
            <div className="flex-shrink-0">
              <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <div>
              <h4 className="text-sm font-semibold text-gray-900 mb-2">Clinical Interpretation</h4>
              <p className="text-sm text-gray-700 leading-relaxed">
                The comparison shows Tali-cel demonstrates competitive survival rates
                compared to globally approved CAR-T products. Use the toggle buttons above to switch between
                disease types (B-ALL and NHL) and survival metrics (PFS and OS) to explore different data views.
              </p>
            </div>
          </div>
        </div>
        */}

        <div className="mt-4 bg-amber-50 border border-amber-200 rounded-lg px-3 py-2">
          <p className="text-xs text-gray-700">
            <span className="font-bold">Note:</span> Tali-cel comparison data is for patients infused up to December 2025, with last follow-up in April 2026.
          </p>
        </div>
      </div>
    </div>
  );
};

export default GlobalCARTBenchmark;
